<template>
    <div
        class="sidebar-content"
        :style="{ 'background-color': sidebar_color }"
    >
        <!-- User menu -->
        <div class="sidebar-section d-lg-none navbar-custom-bg">
            <div class="sidebar-section-body">
                <div class="d-flex justify-content-between">
                    <img v-if="topbar.logo && topbar.logo.src" :src="topbar.logo.src" :alt="app.name ? app.name : 'Laravel'" style="height: 30px;">
                    <div v-else style="height: 30px;">{{ (app.name ? app.name : 'Laravel') }}</div>

                    <!-- Toggle buttons -->
                    <button type="button" class="btn btn-outline-light-100 text-white border-transparent btn-icon rounded-pill btn-sm sidebar-control sidebar-main-toggle d-none d-lg-inline-flex">
                        <i class="icon-transmission"></i>
                    </button>

                    <button type="button" class="btn btn-outline-light-100 text-white border-transparent btn-icon rounded-pill btn-sm d-lg-none" @click="toggleMobileSidebar">
                        <i class="icon-cross2"></i>
                    </button>
                    <!-- /toggle buttons -->
                </div>
            </div>
        </div>
        <!-- /user menu -->

        <!-- Main navigation -->
        <div class="sidebar-section">
            <ul v-if="sidebar.menu.items.length > 0" class="nav nav-sidebar" data-nav-type="accordion">
                <limitless-sidebar-nav-item
                    v-for="item in sidebar.menu.items"
                    :key="item.mvid"
                    :title="item.title"
                    :icon="item.icon"
                    :url="item.url"
                    :route="item.route"
                    :target="item.target"
                    :children="item.children"
                    :tag="item.active_tag"
                    :active-tag="sidebar.menu.active_tag"
                ></limitless-sidebar-nav-item>
            </ul>
            <div v-else-if="sidebar.menu.error" class="text-center pt-5" style="height: 400px;">
                <i class="text-danger">{{ sidebar.menu.error }}</i>
            </div>
            <div v-else-if="sidebar.menu.loading" class="text-center pt-5" style="height: 400px;">
                <i class="icon-spinner spinner"></i>
            </div>
        </div>
        <!-- /main navigation -->
    </div>
</template>

<script>
import { mapState } from 'pinia';
import eventBus from '@services/EventBus.js';
import { useLayoutHandlerStore } from '@services/pinia/LayoutHandlerStore';
import LimitlessSidebarNavItem from './LimitlessSidebarNavItem.vue';

export default {
    name: 'LimitlessSidebarContent',
    components: {
        LimitlessSidebarNavItem,
    },
    computed: {
        ...mapState(useLayoutHandlerStore, ['app', 'sidebar', 'topbar', 'override']),
        sidebar_color() {
            // eslint-disable-next-line no-nested-ternary
            return (this.override.sidebar_color ? this.override.sidebar_color : (this.sidebar.color ? this.sidebar.color : 'inherit'));
        },
    },
    methods: {
        toggleMobileSidebar() {
            eventBus.$emit('toggle:sidebar-mobile');
        },
    },
};
</script>
